import React, { useState } from "react";
import { ReactSortable } from "react-sortablejs";
import BuilderModal from "../../../../../../Layouts/Modal/BuilderModal";
import IconPreview from "../../../../../../components/BuilderComponents/Preview/IconPreview";
import { useAppBlocksContext } from "../../../../../../context/AppBlocksContext";
import { getFieldIcon } from "../../../../../../utils/getFieldIcon";
import RecordsetListCardDesign from "../../../../DetailsViewRenderer/Desktop/RecordsetListCardDesign";
import MaterialIcon from "../../../../../../components/BuilderComponents/MaterialIcon";

const ListOfColumns = ({
  editColumn,
  tableRef,
  afterEffectOfFilter,
  setIsModalOpen,
  showEditColumnBar,
  setEditColumn
}) => {
  const { recordsviewLayout, setRecordsviewLayout, applicationBlockData } = useAppBlocksContext();
  const [isGridModalOpen, setIsGridModalOpen] = useState(false);
  const setFieldAfterRearrange = (newArr) => {
    const layoutCopy = { ...recordsviewLayout };
    layoutCopy.columns = newArr;
    if (editColumn.show) {
      let PreviousObject = { index: "", type: "" };
      layoutCopy.columns.forEach((element, index) => {
        if (element.id === editColumn.payload.id) {
          PreviousObject.index = index;
          PreviousObject.id = element.id;
        }
      });
      showEditColumnBar(PreviousObject.index, PreviousObject.id);
    }
    setRecordsviewLayout(layoutCopy);
  };

  const handleCustomButtonsReorder = (list, index) => {
    // setCustomColIndex("");
    const newObj = JSON.parse(JSON.stringify(recordsviewLayout));
    newObj.columns[index].config = list;
    setRecordsviewLayout(newObj);
  };

  const handleSaveRecordsetLayout = (data) => {
    const copyRecordviewlayout = JSON.parse(JSON.stringify(recordsviewLayout));
    const colIndex = copyRecordviewlayout.columns.findIndex((col) => col.id === isGridModalOpen.i);
    if (colIndex !== -1) {
      if (!copyRecordviewlayout.columns[colIndex].layout_config) {
        copyRecordviewlayout.columns[colIndex].layout_config = {};
      }
      copyRecordviewlayout.columns[colIndex].layout_config.layouts = data;
      setRecordsviewLayout(copyRecordviewlayout);
      setIsGridModalOpen({ type: "" });
    }
  };

  const deleteComun = (index) => {
    const newObj = JSON.parse(JSON.stringify(recordsviewLayout));
    const newArray = newObj.columns.filter((_, i) => i !== index);
    newObj.columns = newArray;
    setRecordsviewLayout(newObj);
    // setColIndex("");
    // setCustomColIndex("");
    if (newObj?.columns.length !== 0) {
      // showEditCustomColumn(0, newObj?.columns[0]?.type);
    }
    afterEffectOfFilter(newObj);
  };

  const deleteColumnElement = (index, id, elementIndex) => {
    const newObj = JSON.parse(JSON.stringify(recordsviewLayout));
    const newArray = newObj.columns[index]?.config?.filter((ele, i) => i !== elementIndex);
    newObj.columns[index].config = newArray;
    setRecordsviewLayout(newObj);
    setEditColumn({
      show: false,
      payload: null
    });
  };

  const handleCustomOpenConfig = (columnIndex, id, customButtonIndex, buttonId) => {
    showEditColumnBar(columnIndex, id, customButtonIndex, buttonId);
  };

  const renderFieldName = (type, field) => {
    switch (type) {
      case "appuser":
        return (
          <p className="default_label">
            {"Appuser"}.{field.display}
          </p>
        );
      default:
        return <p className="default_label">{field.prefix + "." + field.display}</p>;
    }
  };

  const getLayoutDataForColumn = (id) => {
    try {
      if (!id) {
        throw new Error("Column ID is required");
      }

      const column = recordsviewLayout?.columns?.find((c) => c.id === id);

      if (!column) {
        console.warn(`Column with ID ${id} not found`);
        return [];
      }

      if (!column.layout_config || !column.layout_config.layouts) {
        console.warn(`Layout config for column with ID ${id} is missing or incomplete`);
        return [];
      }

      return column.layout_config.layouts;
    } catch (error) {
      console.error("Error getting layout data for column:", error);
      return [];
    }
  };

  return (
    <div className="left_panel_field_container">
      {recordsviewLayout?.columns?.length > 0 && (
        <ReactSortable
          filter=".addImageButtonContainer"
          handle=".Recordsviewfielddragclass"
          list={recordsviewLayout.columns}
          setList={setFieldAfterRearrange}
          animation="200"
          easing="ease-out"
          className="flex_column gap_3 mb_3"
        >
          {recordsviewLayout?.columns?.map((field, index) => (
            <div
              key={field.id}
              className={
                editColumn.show && (index === editColumn.payload.index || index === editColumn.payload.index)
                  ? "field_card selected"
                  : "field_card"
              }
            >
              <div className="field_container_upper_part">
                <div className="field_left_container">
                  <MaterialIcon name="drag_indicator" className="Recordsviewfielddragclass drag_icon" />
                  <div>
                    <p className="field_custom_label">{field.custom_label || field.display || field.name}</p>
                  </div>
                </div>
                <div className="icons">
                  {(field.field_type === "grid" ||
                    field.field_type === "recordset" ||
                    field.field_type === "recordset-list") && (
                    <MaterialIcon
                      name="list_alt"
                      className="edit_icon"
                      onClick={() => setIsGridModalOpen({ type: "recordset_layout", i: field.id })}
                    />
                  )}
                  <MaterialIcon name="edit" className="edit_icon" onClick={() => showEditColumnBar(index, field.id)} />
                  <MaterialIcon name="delete" className="delete_icon" onClick={() => deleteComun(index)} />
                </div>
              </div>
              {field?.type === "custom" ? (
                field.config.length !== 0 && <hr className="field_break_line" />
              ) : (
                <hr className="field_break_line" />
              )}
              <div className="field_container_lower_part">
                {field?.type === "custom" ? (
                  <div className="custom_container">
                    {field.custom_type !== "aggregate_column" &&
                      field.custom_type !== "rich_column" &&
                      field?.config?.length !== 0 && (
                        <ReactSortable
                          handle=".Customfielddragclass"
                          list={field.config}
                          setList={(list) => handleCustomButtonsReorder(list, index)}
                          animation="200"
                          easing="ease-out"
                          className="custom_element_container"
                        >
                          {field.config.map((element, elementIndex) => (
                            <div
                              className={element?.type === "button" ? "field_custom_button" : "field_custom_dropdown"}
                              style={{
                                backgroundColor:
                                  editColumn.show && elementIndex === editColumn.payload.subIndex ? "#4A1FB8" : ""
                              }}
                              key={element.id}
                              onClick={() => handleCustomOpenConfig(index, field.id, elementIndex, element.id)}
                            >
                              <MaterialIcon name="drag_indicator" className="Customfielddragclass drag_icon" />
                              <p className="custom_button_view">
                                {element?.icon && (
                                  <IconPreview icon={element.icon || ""} customStyle={{ fontSize: "16px" }} />
                                )}

                                {element?.name}
                                {element?.type === "dropdown" && <MaterialIcon name="expand_more" />}
                              </p>
                              <MaterialIcon
                                name="close"
                                className="close"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  deleteColumnElement(index, field.id, elementIndex, element.id);
                                }}
                              />
                            </div>
                          ))}
                        </ReactSortable>
                      )}
                  </div>
                ) : (
                  <div className="default_container">
                    <div className="default_label_container" onClick={() => setIsModalOpen(index)}>
                      <MaterialIcon name={getFieldIcon(field?.field_type)} />
                      {renderFieldName(applicationBlockData.table_type, field)}
                    </div>
                    <div>
                      {field?.config?.colorif?.[0]?.color ? (
                        <div
                          className={
                            index === editColumn.payload?.index
                              ? "field_color_config_container selected"
                              : "field_color_config_container"
                          }
                          onClick={() => showEditColumnBar(index, field.id)}
                        >
                          <MaterialIcon name="palette" />
                          <div className="field_color_container">
                            {field?.config?.colorif?.map((color, colorindex) => (
                              <div style={{ backgroundColor: color?.color }} key={colorindex}></div>
                            ))}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </ReactSortable>
      )}
      <BuilderModal
        isOpen={isGridModalOpen.type}
        onClose={() => setIsGridModalOpen({ type: "" })}
        modalName="Add Field"
      >
        {isGridModalOpen.type === "recordset_layout" && (
          <RecordsetListCardDesign
            tableRef={tableRef}
            layoutData={getLayoutDataForColumn(isGridModalOpen.i)}
            folderId={[isGridModalOpen.i]}
            handleSaveRecordsetLayout={handleSaveRecordsetLayout}
            tableId={recordsviewLayout.table_id}
            tableType={recordsviewLayout.table_type}
            device={applicationBlockData.device}
          />
        )}
      </BuilderModal>
    </div>
  );
};

export default ListOfColumns;
